<template>
  <div class="closedloop">
    <div class="header">
      <div class="title">工单流程闭环</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <img :src="closedloopLogo" alt="" />
      </div>
      <div class="right">
        <div class="item" v-for="item in closedloopList" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import closedloopLogo from "../../../../assets/product/closedloopLogo.png";

export default {
  setup() {
    return reactive({
      closedloopLogo: closedloopLogo,
      closedloopList: [
        {
          id: 1,
          title: "全程闭环",
          text: "待完成的事项的工单无需进行二次申请，系统自动导入新工单，提升效率。",
        },
        {
          id: 2,
          title: "进度消息提醒",
          text: "工单后台智能分析，进度消息全程提醒。",
        },
        {
          id: 3,
          title: "自动派单",
          text: "有任务系统自动派单，智能协助运营，提升客户满意度。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.closedloop {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
}
.body .left img {
  width: 735px;
  margin-right: 60px;
}
.body .right .item {
  margin-bottom: 40px;
}
.body .right .item .text {
  margin-top: 20px;
  font-size: 14px;
}
</style>
